'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TouchFeedback = require('./src/TouchFeedback');

var _TouchFeedback2 = _interopRequireDefault(_TouchFeedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _TouchFeedback2['default']; // based on 2.0.0